import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

class ApplicableContracts extends Component {
  renderApplicableContracts = () => {
    const { applicableContracts } = this.props.projectStore
    return applicableContracts.map((contract, index) => {
      const seperator = index + 1 >= applicableContracts.length ? '' : ', '
      return (
        <span
          key={contract.id}
          onClick={() =>
            this.props.sidebarStore.openSidebar({
              template: 'contract',
              id: contract.id
            })
          }
        >
          {contract.contractReference + seperator}
        </span>
      )
    })
  }

  render () {
    const { applicableContracts } = this.props.projectStore
    if (applicableContracts.length) {
      return (
        <div className='applicable-contracts__wrapper'>
          <div className='applicable-contracts-label'>
            Applicable contracts:
          </div>
          <div className='applicable-contracts-label__list applicable-contracts-label__list--link'>
            {this.renderApplicableContracts()}
          </div>
        </div>
      )
    }

    return null
  }

  static propTypes = {
    sidebarStore: PropTypes.object,
    projectStore: PropTypes.object
  }
}

export default inject('sidebarStore', 'projectStore')(
  observer(ApplicableContracts)
)
